import css from './carousel.module.scss';
import { CarusselItem } from './carousel';
import classNames from 'classnames';
import { ReactComponent as KBimage } from 'src/assets/services/navbar/knowledgebase.svg';

interface Props {
  item: CarusselItem;
  hide?: boolean;
  onClick?: (slug: string) => void;
}

function CarouselCard({ item, hide, onClick }: Readonly<Props>) {
  return (
    <div
      className={classNames(css.carousel_card, { [css.hidden]: hide })}
      onClick={() => onClick?.(item.slug)}
      aria-hidden>
      <img src={item.imgUrl} alt={item.imgUrl} className={classNames(css.slide)} />
      {item?.itemsQuantity && (
        <p>
          <KBimage />
          {item.itemsQuantity} лекцій
        </p>
      )}
      <h3>{item.title}</h3>
      <p>{item.description}</p>
    </div>
  );
}

export default CarouselCard;
